import type { IProduct } from "@src/types/AppTypes";
import { createContext } from "react";

export const ProductsContext = createContext<{
  products: IProduct[];
  setProducts: React.Dispatch<{
    payload: IProduct[];
    type: "updateProducts";
  }>;
}>({ products: [], setProducts: () => { } });

export function productsReducer(
  state: IProduct[],
  action: { payload: IProduct[]; type: "updateProducts" }
) {
  if (action.type === "updateProducts") {
    return action.payload
  } else {
    return state
  }
}